import { createContext, useContext, useEffect, useState } from "react";
import { api, setAuthToken, getAuthToken } from "../lib/apiClient";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = unauth, object = user
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    (async () => {
      const hasToken = !!getAuthToken();
      if (!hasToken) {
        if (mounted) { setUser(false); setLoading(false); }
        return;
      }
      try {
        const { data } = await api.get("/auth/me");
        if (mounted) setUser(data);
      } catch {
        setAuthToken(null);
        if (mounted) setUser(false);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, []);

  async function login(email, password) {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.access_token) setAuthToken(data.access_token);
    setUser(data.user);
    return data.user;
  }

  async function register(payload) {
    const { data } = await api.post("/auth/register", payload);
    if (data.access_token) setAuthToken(data.access_token);
    setUser(data.user);
    return data.user;
  }

  async function logout() {
    try { await api.post("/auth/logout"); } catch {}
    setAuthToken(null);
    setUser(false);
  }

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, setUserExternal: setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
